import { useEffect, useState } from 'react';

import { useCustomizationStore } from '@/widgets/widgets-slider';

import {
  useAccountStore,
  useAccountsHook,
  useRequisitesHook,
  useRequisitesStore,
  useVabsAccountsStore,
} from '@/entities/currency-account';
import { usePersonalStore } from '@/entities/user';

import { KybStepStatus } from '@/shared/api';
import { AccountBg1 } from '@/shared/assets';

export const useAccountsController = () => {
  const [isLoadingAccs, setIsLoading] = useState(true);

  const setAccounts = useVabsAccountsStore((state) => state.setAccounts);
  const currentAccounts = useVabsAccountsStore((state) => state.accounts);
  const setRequisites = useRequisitesStore((state) => state.setRequisites);
  const setAccountId = useVabsAccountsStore((state) => state.setAccountId);
  const setAccount = useAccountStore((state) => state.setAccount);
  const setTotalAccount = useAccountStore((state) => state.setTotalAccount);
  const setTotalBalanceAcc = useVabsAccountsStore(
    (state) => state.setTotalBalanceAcc,
  );

  const accountId = useVabsAccountsStore((state) => state.accountId);
  const company = usePersonalStore((state) => state.company);
  const totalWidget = useCustomizationStore((state) => state.totalWidget);
  const setTotalWidget = useCustomizationStore((state) => state.setTotalWidget);

  const { data: accounts, isLoading: isLoadingAccounts } = useAccountsHook(
    company?.status === KybStepStatus.Successful,
  );

  const currencyIds = accounts?.reduce<string[]>((acc, account) => {
    if (account.status === 'ACTIVE' && Boolean(account.currencyId)) {
      return [...acc, account.currencyId];
    }
    return acc;
  }, []);

  const { data: requisites, isLoading: isLoadingRequisites } =
    useRequisitesHook(accountId, currencyIds ?? []);

  useEffect(() => {
    if (!accounts?.length) return;

    if (!currentAccounts?.length) {
      //first load
      const usdAcc = accounts.find((i) => i.code === 'USD');
      if (usdAcc) {
        const total = { ...usdAcc, id: 'all', imgSrc: AccountBg1 };
        const acc = accounts.find(
          (account) =>
            account.status === 'ACTIVE' && account.code === totalWidget,
        );
        if (!acc) {
          setTotalWidget('all');
        }
        setTotalBalanceAcc(total); //global
        setTotalAccount(acc || total); //in select
      }
      const activeAccount = accounts.find(
        (account) => account.status === 'ACTIVE',
      );

      if (!activeAccount?.virtualId) return;
      setAccountId(activeAccount.virtualId);
      setAccount(activeAccount);
    }
    setAccounts(accounts);
  }, [accounts]);

  useEffect(() => {
    if (!requisites) return;
    setRequisites(requisites);
  }, [requisites]);

  useEffect(() => {
    if (!localStorage.getItem('@accessToken')) {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    setIsLoading(isLoadingAccounts);
  }, [isLoadingAccounts, isLoadingRequisites]);

  return isLoadingAccs;
};
